import { TasklistService } from '@/api/tasklist'
import { DefaultButton } from '@/components/ui/Button'

export default function TableVariable({ variables }: { variables: Record<string, any> }) {
  const { mutate, isLoading } = TasklistService.useDownloadFile()

  const handleClick = (urlDownload: string, label: string) => {
    mutate({ urlDownload: urlDownload, name: label })
  }

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-sm text-left table text-gray-500 ">
        <thead className="text-xs text-gray-700 uppercase bg-gray-200">
          <tr>
            <th scope="col" className="px-6 py-3">
              Name
            </th>
            <th scope="col" className="px-6 py-3">
              Value
            </th>
          </tr>
        </thead>
        <tbody>
          {variables &&
            Object.entries(variables)
              .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
              .map(([key, value], index) => (
                <tr key={index} className="bg-white border-b ">
                  <td scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                    {key}
                  </td>
                  <td className="px-6 py-4">
                    {typeof value === 'string' &&
                    (value.includes('history/variable-instance') ||
                      value.includes('minio') ||
                      value.includes('/download/')) ? (
                      <DefaultButton onClick={() => handleClick(value, key)} type="button" loading={isLoading}>
                        Download {key}
                      </DefaultButton>
                    ) : (
                      <div className="w-52">{typeof value === 'object' ? JSON.stringify(value) : String(value)}</div>
                    )}
                  </td>
                </tr>
              ))}
        </tbody>
      </table>
    </div>
  )
}
